import React, { Component } from 'react';
import './loading.css';

export class Loading extends Component {
    render() {
        return (
            <div id="loader-page" className='loadingBg' >
                <div className="loader-container">
                    <div className="loader"></div>
                </div>
            </div>
        );
    }
}